import { Injectable, inject } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanMatch,
  Route,
  UrlSegment,
} from '@angular/router';
import { NotificationService } from '@core/services/notification.service';
import { UserService } from '@core/services/user.service';
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanMatch {
  private router = inject(Router);
  private userService = inject(UserService);
  private notificationService = inject(NotificationService);

  title: string;
  desc: string;
  token: string;
  appId: string;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.appId = this.userService.getAppId();
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    if (this.toHaveAccess) {
      return true;
    }

    this.notificationService.error(this.desc, this.title);
    this.router.navigate(['auth', 'tenant', this.appId]);

    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.toHaveAccess) {
      return true;
    }

    this.notificationService.error('COMMONS.ERROR.ROUTING_ERROR', 'COMMONS.ERROR.TITLE');
    this.router.navigate(['auth', 'tenant', this.appId], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }

  private get toHaveAccess(): boolean {
    let isLoggedIn;

    this.userService.isLoggedIn$.subscribe((res) => {
      isLoggedIn = res;
    });

    return isLoggedIn;
  }
}
